import React, { useEffect, useState } from "react";
import "./GlobalAccountSearchLeftPanel.css";
import { pxToRem } from "../../../../utilities/uiUtils";
import SearchOrAddDropdown from "../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/NurtureCampaignContact/SearchOrAddDropdown";
import companyTypeMap from "../companyType.json";
import { dbGet } from "../../../../utilities/db";
import  "../../GlobalContacts/GlobalContactSideFilter.css";
import { ChipsDropdown,CheckboxChipsDropdown } from "../../genericComponents/uiElements/GlobalDashBoardComponents/GlobalDashBoardComponents";
import { SearchDropdown } from "../../genericComponents/uiElements/GlobalDashBoardComponents/GlobalDashBoardComponents";
function GlobalAccountSearchLeftPanel({ companyData, setCompanyData }) {
  const [showClear, setShowClear] = useState(false);
  const [industriesData,setIndustriesData]=useState([])
  const [regionData,setRegionData] = useState([]);
  const  [countryData,setCountryData] = useState([]);
  // ✅ Check if any field has a value
  useEffect(() => {
    const hasValues =
      (companyData.company_name && companyData.company_name.length > 0) ||
      (companyData.industries && companyData.industries.length > 0) ||
      (companyData.yearfounded && companyData.yearfounded.length > 0) ||
      (companyData.country && companyData.country.length > 0) ||
      (companyData.employees && companyData.employees.length > 0) ||
      (companyData.region && companyData.region.length > 0) ||
      companyData.companytypeid !== null;

    setShowClear(hasValues);
  }, [companyData]);

  // ✅ Reset all filters
  const handleClearAll = () => {
    setCompanyData({
      company_name: [],
      industries: [],
      yearfounded: [],
      country: [],
      employees: [],
      companytypeid: null,
      region: [],
    });
  };
  

useEffect(() => {
  let attempts = 0;
  let intervalId;

  const KEYS = [
    { key: "industriesDropdown", setter: setIndustriesData },
    { key: "regionDropdown", setter: setRegionData },
    { key: "countryDropdown", setter: setCountryData },
  ];

  async function tryFetch() {
    attempts++;

    const results = await Promise.all(
      KEYS.map(({ key }) => dbGet(key))
    );

    let allLoaded = true;

    results.forEach((cached, i) => {
      const { key, setter } = KEYS[i];
      if (Array.isArray(cached) && cached.length > 0) {
        console.log(`✅ Loaded from IndexedDB: ${key} (${cached.length})`);
        setter(cached);
      } else {
        console.log(`⏳ Retry ${attempts}/5 — ${key} not ready yet`);
        allLoaded = false;
      }
    });

    if (allLoaded) {
      clearInterval(intervalId);
    } else if (attempts >= 5) {
      clearInterval(intervalId);
      console.warn("❌ IndexedDB data still not found after 5 attempts");
    }
  }

  // First attempt immediately
  tryFetch();

  // Retry every 300ms up to 5 times
  intervalId = setInterval(tryFetch, 300);

  return () => clearInterval(intervalId);
}, []);

  const mapToOption = (arr) =>
    arr.map((val) => ({ label: val[1], value: val[0] }));

  return (
   
    <div className="gcsf-container" style={{width:pxToRem(300)}}>
      
      <div className="nccs-field" style={{ marginTop: "0.8rem" }}>
  <div className="gaslp_header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <h3>Account Filters</h3>
    <button
      className="clear_all_btn"
      style={{ visibility: showClear ? 'visible' : 'hidden',fontSize:"14px"}}
      onClick={handleClearAll}

    >
      Clear All
    </button>
  </div>
</div>


      
        {/* <div className="nccs-field" style={{ marginTop: "1rem" }}>
        <SearchOrAddDropdown
          placeholder="Choose a Company Type"
          options={mapToOption(Object.entries(companyTypeMap))}
          value={companyData?.companytypeid}
          onChange={(val) => {
            setCompanyData((prev) => ({
              ...prev,
              companytypeid: val,
            }));
          }}
          mode="single"
          showCount={false}
          noEditPlaceHolder={false}
        />
        </div> */}
      
     
     <div className="nccs-field" style={{ marginTop: "1rem" }}>
  <SearchDropdown
    placeholder="Company Name"
    selectedValues={companyData?.company_name}
    setSelectedValues={(val) => {
      setCompanyData((prev) => ({
        ...prev,
        company_name: val,
      }));
    }}
  />
</div>


     <div className="nccs-field" style={{ marginTop: "1rem" }}>
      <CheckboxChipsDropdown
        key={industriesData?.length}
        options={industriesData}
        placeholder={"Industries"}
        selectedValues={companyData?.industries}
        setSelectedValues={(val) => {
          setCompanyData((prev) => ({
            ...prev,
            industries: val,
          }));
        }}
      />
     </div>
      <div className="nccs-field" style={{ marginTop: "1rem" }}>
      <ChipsDropdown
        placeholder={"Year Founded"}
        inputType="numberOnly" 
        placeholderStyle={{
        fontSize: "0.81rem",
        color: "#4b5563",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
        selectedValues={companyData?.yearfounded}
        setSelectedValues={(val) => {
          setCompanyData((prev) => ({
            ...prev,
            yearfounded: val,
          }));
        }}
        validateInput={(val) => {
        const year = parseInt(val, 10);
        return !isNaN(year) && year >= 1100; // only allow year >= 1100
    }}
      />
      </div>
      <div className="nccs-field" style={{ marginTop: "1rem" }}>


            <CheckboxChipsDropdown
        key={countryData?.length}
        options={countryData}
         placeholder={"Country"}
        selectedValues={companyData?.country}
        setSelectedValues={(val) => {
          setCompanyData((prev) => ({
            ...prev,
            country: val,
          }));
        }}
      />
      </div>
      <div className="nccs-field" style={{ marginTop: "1rem" }}>
      <ChipsDropdown
        placeholder={"Employee Count"}
        inputType="numberOnly"
        placeholderStyle={{
          fontSize: "0.81rem",
          color: "#4b5563",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        selectedValues={companyData?.employees}
        setSelectedValues={(val) => {
           const formatted = val.map((v) => {
           
            let num = parseFloat(v?.id || v?.label);

            
            num = num?.toFixed(1);
             
            return { id: num?.toString(), label: num?.toString() };
            
          });

          setCompanyData((prev) => ({
            ...prev,
            // employees: val,
            employees: formatted,
          }));
        }}
      />
      </div>
      <div className="nccs-field" style={{ marginTop: "1rem" }}>
      {/* <ChipsDropdown
        placeholder={"Region"}
        placeholderStyle={{
        fontSize: "0.81rem",
        color: "#4b5563",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
        selectedValues={companyData?.region}
        setSelectedValues={(val) => {
          setCompanyData((prev) => ({
            ...prev,
            region: val,
          }));
        }}
      /> */}
      <CheckboxChipsDropdown
        key={regionData?.length}
        options={regionData}
        placeholder={"Region"}
        selectedValues={companyData?.region}
        setSelectedValues={(val) => {
          setCompanyData((prev) => ({
            ...prev,
            region: val,
          }));
        }}
      />
      </div>
    </div>
  );
}

export default GlobalAccountSearchLeftPanel;